import { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import SpeedDialIcon from "@mui/material/SpeedDialIcon";
import { SpeedDial, SpeedDialAction } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import { mdiEye, mdiFileEditOutline, mdiTrashCanOutline } from "@mdi/js";
import { toast } from "react-toastify";
import { Avatar } from "@mui/material";
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

import { endpointPrincipal } from "../../../api/endPoints/endpointPrincipal/endpointPrincipal";

import ContainerTitulo from "../../../components/Formularios/Container/ContainerTitulo";
import InputSemBorda from "../../../components/Formularios/Inputs/InputsSemBorda";
import { showConfirmationDialog } from "../../../components/Formularios/Modal/ModalExcluir";
import { Button } from "../../../components/Formularios/Buttons/Button";

import { AgenteInterface } from "../../../types/AgenteInterface";

export const Agente: React.FC = () => {
  const navigate = useNavigate();

  const [agentes, setAgentes] = useState<AgenteInterface[] | null>(null);
  const [isCarregando, setIsCarregando] = useState(false);

  const excluirAgente = async (agente: AgenteInterface) => {
    const agenteId = agente?.id_agente!;
    await showConfirmationDialog(
      "Excluir Agente",
      `Tem certeza que deseja excluir o agente \n ${agente.nome}?`,
      "question",
      "Excluir",
      "Cancelar"
    )
      .then((result) => {
        if (result.confirmed) {
          excluirAgentePorId(agenteId);
        }
      })
      .catch((erro) => {
        toast.error(
          `Erro ao excluir registro. Motivo: ${erro.response.data.message}`
        );
      });
  };

  async function excluirAgentePorId(id: number) {
    setIsCarregando(true);
    try {
      await endpointPrincipal.delete(`/agentes/${id}`);
      buscarTodosAgentes();
      toast.success("Agente excluído com sucesso");
    } catch (error: any) {
      toast.error(`Erro ao excluir : ${error.response.data.message}`);
    } finally {
      setIsCarregando(false);
    }
  }

  async function buscarTodosAgentes() {
    setIsCarregando(true);
    try {
      const sucesso = await endpointPrincipal.get("/agentes/nao-registrados");
      setAgentes(sucesso?.data);
    } catch (error: any) {
      toast.error(`Erro ao buscar agentes: ${error.response.data.message}`);
    } finally {
      setIsCarregando(false);
    }
  }

  useEffect(() => {
    buscarTodosAgentes();
  }, []);

  interface Action {
    icon: JSX.Element;
    name: string;
  }
  
  const actions: Action[] = [
    {
      icon: <AddIcon onClick={() => navigate("novo")} />,
      name: "Incluir",
    },
  ];

  return (
    <>
      <div className="container-fluid mt-2">
        <ContainerTitulo titulo="Agentes" />
        <Card>
          <Card.Body>
            <Row>
              <SpeedDial
                ariaLabel="SpeedDial basic example"
                direction="left"
                sx={{
                  right: 0,
                  position: "absolute",
                }}
                icon={<SpeedDialIcon />}
              >
                {actions.map((action) => (
                  <SpeedDialAction
                    key={action.name}
                    icon={action.icon}
                    tooltipTitle={action.name}
                  />
                ))}
              </SpeedDial>
            </Row>

            <Row>
              <div className="d-flex my-2 gap-1 ">
                <Col sm={11}>
                  <InputSemBorda
                    name="agente"
                    type="text"
                    value={""}
                    onChange={() => {}}
                    classNameInputsSemBorda="form-control bordasInferiorInput text-capitalize"
                    placeholder=" "
                    label="Pesquisar"
                  />
                </Col>
              </div>
            </Row>
            <div className="table-responsive">
              <table className="table table-centered w-100 dt-responsive nowrap table-striped table-hover">
                <thead className="table-cabecalho">
                  <tr>
                    <th></th>
                    <th>Nome</th>
                    <th>Email</th>
                    <th>Função</th>
                    <th>Grupos</th>
                    <th>Último Acesso</th>
                    <th className="text-end px-4">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {agentes?.map((agente: AgenteInterface) => (
                    <tr key={agente.id_agente}>
                      <td>
                        <Avatar 
                          src={agente.avatar} 
                          alt={agente.nome}
                          sx={{ width: 32, height: 32 }}
                        >
                          {agente.nome?.charAt(0)}
                        </Avatar>
                      </td>
                      <td>{agente.nome}</td>
                      <td>{agente.email}</td>
                      <td>{agente.funcao_descricao || agente.funcao}</td>
                      <td>{agente.grupo_descricao || agente.grupo}</td>
                      <td>
                        {agente.ultimo_acesso 
                          ? format(new Date(agente.ultimo_acesso), 'dd/MM/yyyy HH:mm', { locale: ptBR })
                          : ''
                        }
                      </td>
                      <td className="text-end">
                        <Button
                          onclick={() => navigate(`visu/${agente.id_agente}`)}
                          icone={mdiEye}
                          type="button"
                          className="botaoTransparente"
                          title={"Visualizar"}
                        />
                        <Button
                          onclick={() => navigate(`editar/${agente.id_agente}`)}
                          icone={mdiFileEditOutline}
                          type="button"
                          className="botaoTransparente"
                          title={"Editar"}
                        />
                        <Button
                          onclick={() => excluirAgente(agente)}
                          icone={mdiTrashCanOutline}
                          type="button"
                          className="botaoTransparente"
                          title={"Excluir"}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Card.Body>
        </Card>
      </div>
    </>
  );
}; 